export default (theme) => ({
  button: {
    color: 'white',
    borderColor: 'white',
  },
  rightIcon: { marginRight: theme.spacing(1) },
});
